<template>
  <div class="recordPage">
    <Header :pageTitle="'练习记录'" v-if="isApp"></Header>
    <!-- tab栏 -->
    <ul class="tabContainer">
      <li
        v-for="(item, key) in tabList"
        :class="{ active: item.value === tabValue }"
        @click.stop="chooseTab(item.value)"
        :key="key"
      >
        {{ item.label }}
        <span v-if="item.value != 'ALL' && item.value === tabValue"
          >({{ totalNum }})</span
        >
      </li>
    </ul>
    <!-- 无数据 -->
    <BScroll @callBack="scrollPagination" ref="scroll">
      <template v-slot>
        <div class="recordAll">
          <ul v-for="(item, index) in recordList" :key="index">
            <!-- line = 'OFFLINE' 病例已下线 -->
            <li
              class="allBox"
              @click.stop="toDetail(item.paperId)"
              v-if="item.line !== 'OFFLINE'"
            >
              <!-- 全部 -->
              <div class="recordLeft">
                <!-- 已完成 -->
                <img
                  src="@/assets/img/exercise/complete.png"
                  alt=""
                  v-if="item.status == 'FINISHED_WITHOUT_WRONG'"
                />
                <!-- 未完成 -->
                <img
                  src="@/assets/img/exercise/practiceUndone.png"
                  alt=""
                  v-else-if="item.status == 'UNFINISHED'"
                />
                <!-- 已完成有错题 = 未完成 -->
                <img
                  src="@/assets/img/exercise/practiceEerror.png"
                  alt=""
                  v-else-if="item.status == 'FINISHED_WITH_WRONG'"
                />
              </div>
              <div class="recordRight">
                <div class="recordTitle overflow">{{ item.medicaseName }}</div>
                <div class="from overflow" v-if="item.experts.length">
                  <span class="expertName" v-for="(info, key) in item.experts" :key="info.expertId">&nbsp;{{(key > 0 ? '、' : '') + info.expertName }}</span>
                  <span>&nbsp;{{ item.experts[0]['hospitalName'] }}</span>
                </div>
                <div class="completeText">
                  完成
                  <span class="recordNumber">{{
                    item.finishedQuestionCount
                  }}</span
                  >/{{ item.totalQuestionCount }}
                  <span class="recordTime">{{ item.updatedDate }}</span>
                </div>
              </div>
            </li>
            <li class="allBox" v-else>
              <!-- 全部 -->
              <div class="recordLeft lineStatus">
                <!-- 已完成 -->
                <img
                  src="@/assets/img/exercise/complete.png"
                  alt=""
                  v-if="item.status == 'FINISHED_WITHOUT_WRONG'"
                />
                <!-- 未完成 -->
                <img
                  src="@/assets/img/exercise/practiceUndone.png"
                  alt=""
                  v-else-if="item.status == 'UNFINISHED'"
                />
                <!-- 已完成有错题 = 未完成 -->
                <img
                  src="@/assets/img/exercise/practiceEerror.png"
                  alt=""
                  v-else-if="item.status == 'FINISHED_WITH_WRONG'"
                />
              </div>
              <div class="recordRight">
                <div class="recordTitle overflow" style="color: #b1b1b3">{{ item.medicaseName }}</div>
                <div class="from overflow" v-if="item.experts.length" style="color: #b1b1b3">
                  <span class="expertName" v-for="(info, key) in item.experts" :key="info.expertId">&nbsp;{{(key > 0 ? '、' : '') + info.expertName }}</span>
                  <span>&nbsp;{{ item.experts[0]['hospitalName'] }}</span>
                </div>
                <div class="completeText">该病例已下线</div>
              </div>
            </li>
          </ul>
        </div>
        <Empty
          :text="'暂无练习记录～'"
          v-show="recordList.length == 0 && flag"
        />
        <div class="noMore" v-show="flag && pageNum === pageCount">
          没有更多了
        </div>
      </template>
    </BScroll>
  </div>
</template>
<script>
import Header from '@com/common/Header.vue'
import Empty from '@/components/common/Empty.vue'
import BScroll from '@/components/common/BScroll.vue'
import { userHistory } from '@api/exercise'
import { appPort, userLogin, isLogin } from '@/widget/index'
export default {
  components: {
    Header,
    Empty,
    BScroll
  },
  data() {
    return {
      tabList: [
        {
          label: '全部',
          value: 'ALL'
        },
        {
          label: '未完成',
          value: 'UNFINISHED'
        },
        {
          label: '已完成',
          value: 'FINISHED'
        }
      ],
      tabValue: 'ALL',
      flag: true,
      scroll: false,
      recordList: [],
      pageNum: 1,
      pageCount: 1, // 总页数
      isApp: appPort(),
      totalNum: 0,
      role: '', // 会员：MEMBER 会员过期：MEMBER_EXPIRED 体验会员：TRIAL 过期体验： MEMBER_TRIAL 未购买会员/未体验 GUEST
      depId: this.$route.query.depId || 1
    }
  },
  watch: {
    scroll(newData) {
      if (newData) {
        this.$refs.scroll.domStyle = {
          bottom: 0,
          top: this.isApp ? '1.7rem' : '1rem',
          position: 'fixed',
          left: '50%',
          marginLeft: '-3.75rem'
        }
        this.$nextTick(() => {
          this.$refs.scroll.setBs()
        })
      } else {
        this.$refs.scroll.bs && this.$refs.scroll.bs.destroy()
        this.$refs.scroll.domStyle = {}
      }
    },
    recordList() {
      this.$nextTick(() => {
        this.$refs.scroll.bs && this.$refs.scroll.bs.refresh()
        this.$refs.scroll.bs && this.$refs.scroll.bs.finishPullUp()
      })
    }
  },
  methods: {
    chooseTab(val) {
      this.tabValue = val
      this.pageNum = 1
      /* 切换后滚动清零 */
      this.$nextTick(() => {
        this.$refs.scroll && this.$refs.scroll.scrollTo(0, 0)
      })
      this.userHistory(val)
    },
    toDetail(paperId) {
      // console.log(this.role, 'item.')
      // 未购买会员/未体验 会员/体验 过期进入购买页
      if (
        this.role === 'GUEST' ||
        this.role === 'MEMBER_TRIAL' ||
        this.role === 'MEMBER_EXPIRED'
      ) {
        this.$router.push({
          name: 'guideExam'
        })
      } else {
        this.$router.push({
          name: 'detailExercise',
          params: {
            id: paperId
          },
          query: {
            taskId: 0
          }
        })
      }
    },
    userHistory(tabValue) {
      if (isLogin) {
        if (!this.flag) {
          return
        }
        this.$showLoading()
        this.flag = false
        userHistory({
          filter: tabValue,
          page: this.pageNum,
          departmentId: this.depId
        }).then(res => {
          this.$hideLoading()
          if (res.code === 200) {
            this.role = res.data.role
            // 未加载完成可以继续加载
            this.pageCount = res.data.pages
            this.totalNum = res.data.total
            if (this.pageNum === 1) {
              this.recordList = res.data.items
              // 是否需要上拉加载
              this.scroll = this.pageCount > 1
            } else {
              this.recordList = this.recordList.concat(res.data.items)
            }
            this.flag = true
          } else {
            this.flag = true
            this.$toast(res.message)
          }
        })
      } else {
        userLogin()
      }
    },
    /* 分页 */
    scrollPagination() {
      if (this.pageCount > this.pageNum && this.flag) {
        this.pageNum = this.pageNum + 1
        this.userHistory(this.tabValue)
      }
    }
  },
  mounted() {
    this.userHistory(this.tabValue)
  }
}
</script>
<style lang="scss" scoped>
.recordPage {
  background: #f5f5f7;
  min-height: 100vh;
  overflow: hidden;
}
.tabContainer {
  height: 116px;
  position: relative;
  z-index: 9;
  background: $grayF;
  display: flex;
  align-items: center;
  padding: 0 32px;
  li {
    height: 52px;
    line-height: 52px;
    padding: 0 22px;
    font-size: 28px;
    color: $gray9;
    box-sizing: border-box;
    border: 1px solid rgba($color: #000000, $alpha: 0);
    &.active {
      background: rgba(255, 102, 0, 0.1);
      border-radius: 26px;
      border: 1px solid #ff6600;
      color: $black;
    }
  }
}
.allBox {
  width: 6.86rem;
  background: #ffffff;
  border-radius: 0.16rem;
  margin: 0.2rem 0.32rem 0.32rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.recordLeft {
  img {
    width: 0.84rem;
    height: 0.84rem;
    border-radius: 500%;
    margin: 0.32rem 0.2rem;
  }
}
.lineStatus {
  img {
    opacity: 0.5;
  }
}
.recordRight {
  max-width: 5.42rem;
  margin: 0.28rem 0;
  .from {
    min-height: 40px;
    line-height: 40px;
    font-size: 28px;
    text-indent: 60px;
    background: url('~@/assets/icon/icon_from.png') no-repeat ;
    background-position: 0 2px;
    background-size: 60px auto;
    margin-bottom: 12px;
    .expertName {
      font-size: 28px;
      font-weight: 700;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }
}
.recordTitle {
  font-size: 0.32rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #212224;
  line-height: 0.48rem;
  margin: 0 0.2rem 0.08rem 0;
}
.completeText {
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #969799;
  line-height: 0.4rem;
}
.recordNumber {
  color: #ff6600;
}
.recordTime {
  margin-left: 0.4rem;
}
.overflow {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
